module.exports = __webpack_public_path__ + "1dfb73e22b9119f547fb880568f56ea2.woff2";